import { useState, useEffect, useMemo } from 'react';
import groupsData from '../data/groups.json';

export const useGroups = (filters = {}) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate async load
    const timer = setTimeout(() => setLoading(false), 100);
    return () => clearTimeout(timer);
  }, []);

  const groups = useMemo(() => {
    let result = [...groupsData];

    // Apply search filter
    if (filters.search) {
      const search = filters.search.toLowerCase();
      result = result.filter(g =>
        g.nom.toLowerCase().includes(search) ||
        g.theme?.toLowerCase().includes(search) ||
        g.description?.toLowerCase().includes(search)
      );
    }

    // Apply status filter
    if (filters.statut) {
      result = result.filter(g => g.statut === filters.statut);
    }

    return result;
  }, [filters.search, filters.statut]);

  const getGroup = async (id) => {
    return groupsData.find(g => g.id === parseInt(id)) || null;
  };

  return {
    groups,
    loading,
    error: null,
    pagination: { total: groups.length },
    getGroup,
    loadGroups: () => { },
    createGroup: async () => { },
    updateGroup: async () => { },
    deleteGroup: async () => { },
    getGroupMembers: async () => [],
    addMember: async () => { },
    removeMember: async () => { }
  };
};
